import { deleteCookie, extractCookie, setCookie } from 'lib/web/cookieUtils'

export const LAB_V2_HEADER_BANNER_DISMISSALS_COOKIE = 'labV2HeaderBannerDismissals'

type DismissalMap = Record<string, string>

function dismissalMap(value: string | undefined, now: number): DismissalMap {
  if (!value) {
    return {}
  }

  try {
    const parsed: unknown = JSON.parse(value)
    if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
      return {}
    }

    const active: DismissalMap = {}
    for (const [id, endDate] of Object.entries(parsed)) {
      if (typeof endDate === 'string' && Date.parse(endDate) > now) {
        active[id] = endDate
      }
    }
    return active
  } catch {
    return {}
  }
}

export function dismissedBannerIdsFromCookie(value: string | undefined, now = Date.now()): Set<string> {
  return new Set(Object.keys(dismissalMap(value, now)))
}

export function cookieValueAfterDismissal(
  value: string | undefined,
  id: string,
  endDate: string,
  now = Date.now(),
): string | undefined {
  const dismissals = dismissalMap(value, now)
  if (Date.parse(endDate) <= now) {
    delete dismissals[id]
  } else {
    dismissals[id] = endDate
  }

  return Object.keys(dismissals).length > 0 ? JSON.stringify(dismissals) : undefined
}

function writeDismissalCookie(value: string | undefined) {
  if (!value) {
    deleteCookie(LAB_V2_HEADER_BANNER_DISMISSALS_COOKIE, '/')
    return
  }

  const dismissals = dismissalMap(value, Date.now())
  const latestEnd = Object.values(dismissals).reduce((latest, endDate) => {
    return Math.max(latest, Date.parse(endDate))
  }, 0)
  const ttlSeconds = Math.max(1, Math.ceil((latestEnd - Date.now()) / 1000))
  setCookie(LAB_V2_HEADER_BANNER_DISMISSALS_COOKIE, value, ttlSeconds, '/', 'Lax')
}

export function recordLabV2HeaderBannerDismissal(id: string, endDate: string) {
  const current = extractCookie(document.cookie, LAB_V2_HEADER_BANNER_DISMISSALS_COOKIE)
  writeDismissalCookie(cookieValueAfterDismissal(current, id, endDate))
}
